import firebase from "./firebase";

const hasCustomClaims = (claims) => claims && claims["accessRoutePlanner"];

const auth = firebase.auth();

export const onAuthStateChanged = (fn) =>
  auth.onAuthStateChanged(async (user) => {
    if (user) {
      const token = await user.getIdTokenResult();

      fn(
        hasCustomClaims(token.claims)
          ? {
              ...user,
              uid: token.claims?.uid || user.uid,
            }
          : null
      );
    } else {
      fn(null);
    }
  });

export const getAuthToken = async () => auth.currentUser.getIdToken();

export const login = async () => {
  try {
    const provider = new firebase.auth.GoogleAuthProvider();
    provider.setCustomParameters({
      prompt: "consent",
    });
    const result = await auth.signInWithPopup(provider);
    const tokenResult = await result.user.getIdTokenResult();
    if (!hasCustomClaims(tokenResult.claims)) {
      await logout();
      throw new Error("permission denied");
    }
    return true;
  } catch (e) {
    return false;
  }
};

export const logout = () => auth.signOut();
